module.exports = __webpack_public_path__ + "img/camera-web.57e590c6.svg";